import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { RectangleStackIcon, TrashIcon } from '@heroicons/react/24/outline'
import * as api from '../../api/account'
import Loader from '../Loader'
import { formatPrice } from '../../utils'
import { Button, ErrorText, SectionTitle } from './ui'

const SavedKitsSection = ({ setFlash }) => {
  const [kits, setKits] = useState(null)
  const [error, setError] = useState('')
  const [usuwany, setUsuwany] = useState(null)

  useEffect(() => {
    let anulowane = false
    api.listKits().then((res) => {
      if (anulowane) return
      if (res.ok) setKits(res.data)
      else { setError(res.error); setKits([]) }
    })
    return () => { anulowane = true }
  }, [])

  const usun = async (id) => {
    setUsuwany(id)
    const res = await api.deleteKit(id)
    setUsuwany(null)
    if (!res.ok) { setError(res.error); return }
    setKits((k) => k.filter((x) => x.id !== id))
    setFlash('Zestaw usunięty.')
  }

  if (kits === null) {
    return <div className="flex justify-center py-10"><Loader label="" /></div>
  }

  return (
    <div>
      <SectionTitle hint="Zestawy zapisane w asystencie doboru. Trzymamy je takimi, jakie były w chwili zapisu — z cenami z tamtego dnia.">
        Zapisane zestawy
      </SectionTitle>

      <ErrorText>{error}</ErrorText>

      {kits.length === 0 ? (
        <div className="text-center py-10">
          <RectangleStackIcon className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <p className="text-sm text-gray-500 mb-4">Nie masz jeszcze zapisanych zestawów.</p>
          <Link to="/dobor-zestawu-pv">
            <Button>Dobierz zestaw</Button>
          </Link>
        </div>
      ) : (
        <ul className="space-y-2">
          {kits.map((kit) => {
            const pozycje = (kit.payload && kit.payload.items) || []
            return (
              <li key={kit.id}
                  className="flex items-start gap-3 rounded-xl border border-gray-100 p-4 hover:border-blue-200 transition-colors">
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-semibold text-gray-800">{kit.name}</p>
                  <p className="mt-0.5 text-xs text-gray-400">
                    zapisany {new Date(kit.created_at).toLocaleDateString('pl-PL')}
                    {pozycje.length > 0 && ` · ${pozycje.length} pozycji`}
                  </p>
                  {pozycje.length > 0 && (
                    <ul className="mt-2 space-y-0.5">
                      {pozycje.slice(0, 4).map((it, i) => (
                        <li key={i} className="text-xs text-gray-500 truncate">
                          {it.name || it.model_name || '—'}
                          {it.quantity > 1 && ` × ${it.quantity}`}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="text-right flex-shrink-0">
                  {kit.total_pln != null && (
                    <p className="text-sm font-bold text-blue-600">
                      {formatPrice(kit.total_pln, 0)} zł
                    </p>
                  )}
                  <button
                    type="button"
                    onClick={() => usun(kit.id)}
                    disabled={usuwany === kit.id}
                    title="Usuń zestaw"
                    className="mt-2 text-gray-300 hover:text-red-500 transition-colors disabled:opacity-40"
                  >
                    <TrashIcon className="w-4 h-4" />
                  </button>
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export default SavedKitsSection
